import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import {
  setStateChangedSettings,
  setUserSettings,
  updateUserSettings,
} from "../actionCreators";
import { userSettingsPLACEHOLDER, UserSettingsReducer } from "../types";

const initialState: UserSettingsReducer = { ...userSettingsPLACEHOLDER };

const settingsReducer = reducer(
  initialState,
  on(setUserSettings, (state, { payload: { userSettings } }) => ({
    ...userSettings,
    stateChanged: false,
  })),
  on(updateUserSettings, (state, { payload: { userSettings } }) => ({
    ...userSettings,
    stateChanged: true,
  })),
  on(setStateChangedSettings, (state, { payload: { newState } }) => {
    state.stateChanged = newState;
  })
);

export default settingsReducer;
